// extracted by mini-css-extract-plugin
module.exports = {"marqueeContainer":"styles_marqueeContainer__3ZXXs","rightmarquee":"styles_rightmarquee__3ra3-"};